import { ReleaseNote, ReleaseNoteOrganizationType } from 'models/release-note';

export const resolveOrgType = (orgType: string): ReleaseNoteOrganizationType => {
    if (orgType === 'clinic') return ReleaseNoteOrganizationType.clinic;
    if (orgType === 'lab') return ReleaseNoteOrganizationType.lab;
    return ReleaseNoteOrganizationType.all;
};

export const resolveContent = (releaseNote: ReleaseNote, userLanguage: string): string => {
    const matchedTranslation = releaseNote.translations.find((translation) => translation.language === userLanguage);
    const englishTranslation = releaseNote.translations.find((translation) => translation.language === 'en');
    return matchedTranslation?.content || englishTranslation?.content || '';
};
